import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import { requestPasswordReset } from "../services/userService"
import { getRecaptchaToken } from "../utilities/recaptcha"

export default function ForgotPassword() {
    const [identifier, setIdentifier] = useState("")
    const [error, setError] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!identifier.trim()) {
            setError("Please enter your email address or username")
            return
        }

        setIsSubmitting(true)
        setError("")

        try {
            const recaptchaToken = await getRecaptchaToken("password_reset")
            await requestPasswordReset(identifier.trim(), recaptchaToken)
            setSubmitted(true)
        } catch (err) {
            setError(err.message || "Something went wrong. Please try again.")
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className="auth-container">
            <Helmet>
                <title>Forgot Password - Chaperon</title>
                <meta
                    name="description"
                    content="Request a password reset link for your Chaperon account."
                />
            </Helmet>

            {/* Left Side - Brand/Image Section */}
            <div
                className="auth-image-section"
                style={{
                    backgroundImage: "url(/image/galina-mountain-hike.jpg)",
                }}
            >
                <div className="auth-brand-content">
                    <h1>Forgot Password?</h1>
                    <p>
                        It happens to the best of us. Enter your email or
                        username and we&apos;ll send you a link to get back on
                        track.
                    </p>
                </div>
            </div>

            {/* Right Side - Request Form */}
            <div className="auth-form-section">
                <div className="auth-form-container">
                    {submitted ? (
                        <>
                            <div className="auth-form-header">
                                <h1>Check your email</h1>
                                <p>
                                    If an account exists for{" "}
                                    <strong>{identifier.trim()}</strong>, a
                                    password reset link is on its way. The link
                                    expires in 1 hour.
                                </p>
                            </div>
                            <Link to="/user/login" className="btn-auth-primary">
                                Back to Sign In
                            </Link>
                        </>
                    ) : (
                        <>
                            <div className="auth-form-header">
                                <h1>Reset Password</h1>
                                <p>
                                    Enter your email address or username and
                                    we&apos;ll send you a reset link
                                </p>
                            </div>

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}

                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                className="auth-form"
                            >
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="identifier"
                                        name="identifier"
                                        value={identifier}
                                        onChange={(e) =>
                                            setIdentifier(e.target.value)
                                        }
                                        placeholder="Email or username"
                                        required
                                        autoComplete="username"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn-auth-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            Sending...
                                        </>
                                    ) : (
                                        "Send Reset Link"
                                    )}
                                </button>

                                <div className="text-center mt-3">
                                    <Link
                                        to="/user/login"
                                        className="auth-link"
                                    >
                                        Back to Sign In
                                    </Link>
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
